module.exports = __webpack_public_path__ + "fonts/Inter-100-latin-ext27.1ad231a.woff2";